export default "__VITE_ASSET__DZ$gupfE__"